import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ClipboardModule} from 'ngx-clipboard';

import {SocialSharingComponent} from './social-sharing.component';

import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faLink} from '@fortawesome/free-solid-svg-icons';
import {faFacebook, faGooglePlus, faReddit, faTwitter} from '@fortawesome/free-brands-svg-icons';

@NgModule({
    declarations: [
        SocialSharingComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ClipboardModule,
        FontAwesomeModule
    ],
    exports: [ SocialSharingComponent ]
})

export class SocialSharingModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faLink, faGooglePlus, faTwitter, faFacebook, faReddit);
  }
}
